import { notification } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AlertAction from '../../store/Actions/AlertActions';

function Alert() {
  const alert = useSelector((state) => state.AlertReducer.alertOptions);
  const dispatch = useDispatch();
  useEffect(() => {
    notification.open({
      message: alert.message,
      duration: 3,
      type: alert.type,
      placement: 'top',
      onClose: () => dispatch(AlertAction.HideAlert()),
    });
  }, []);
  return null;
}

export default Alert;
